
import AffiliateHeader from "@/components/affiliate/AffiliateHeader";
import AffiliateHowItWorks from "@/components/affiliate/AffiliateHowItWorks";
import AffiliateBenefits from "@/components/affiliate/AffiliateBenefits";
import AffiliateAgreement from "@/components/affiliate/AffiliateAgreement";
import AffiliateApplicationForm from "@/components/affiliate/AffiliateApplicationForm";
import AffiliateContact from "@/components/affiliate/AffiliateContact";

const Affiliate = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <AffiliateHeader />
        <AffiliateHowItWorks />
        <AffiliateBenefits />
        <AffiliateAgreement />
        <AffiliateApplicationForm />
        <AffiliateContact />
      </div>
    </div>
  );
};

export default Affiliate;
